import React from 'react';
import type { MemberEntryValues } from './memberEntry';

/**
 * 멤버 인증 입력 폼 — 재사용 컴포넌트. 명단 입장: 번호 + 입장번호 / 방 입장번호: 이름 + 입장번호.
 * 상태·검증·전송은 부모가 맡고(validateMemberEntry / buildMemberJoinFrame), 이 컴포넌트는 입력 UI만 그린다.
 * 스타일은 cp-comm-gate-* 클래스를 쓴다(CommStudentPage.css).
 */
type Props = {
  title: string;
  rosterMode: boolean;
  values: MemberEntryValues;
  onChange: (next: MemberEntryValues) => void;
  onSubmit: () => void;
  error?: string;
  busy?: boolean;
  description?: string;
  submitLabel?: string;
};

export default function MemberEntryForm({
  title,
  rosterMode,
  values,
  onChange,
  onSubmit,
  error,
  busy,
  description,
  submitLabel = '입장하기',
}: Props) {
  const set = (patch: Partial<MemberEntryValues>) => onChange({ ...values, ...patch });
  return (
    <form
      className="cp-comm-gate-card"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <h1 className="cp-comm-gate-title">{title}</h1>
      <p className="cp-comm-gate-desc">
        {description ??
          (rosterMode
            ? '내 번호와 나만의 입장번호(6자리)를 입력하고 들어가요.'
            : '선생님께 받은 입장번호와 화면에 보일 이름을 입력하고 들어가요.')}
      </p>
      {rosterMode ? (
        <label className="cp-comm-gate-field">
          <span>번호</span>
          <input
            value={values.number}
            inputMode="numeric"
            maxLength={4}
            autoComplete="off"
            onChange={(e) => set({ number: e.target.value.replace(/\D/g, '') })}
            placeholder="내 번호 (예: 7)"
          />
        </label>
      ) : (
        <label className="cp-comm-gate-field">
          <span>이름</span>
          <input
            value={values.nickname}
            maxLength={20}
            autoComplete="nickname"
            onChange={(e) => set({ nickname: e.target.value })}
            placeholder="화면에 보일 이름"
          />
        </label>
      )}
      <label className="cp-comm-gate-field">
        <span>입장번호</span>
        <input
          className="is-code"
          value={values.code}
          inputMode="numeric"
          maxLength={rosterMode ? 6 : 8}
          autoComplete="off"
          onChange={(e) => set({ code: e.target.value.replace(/\D/g, '') })}
          placeholder={rosterMode ? '나만의 입장번호 6자리' : '선생님이 알려준 번호'}
        />
      </label>
      {error ? (
        <p className="cp-comm-gate-error" role="alert">
          {error}
        </p>
      ) : null}
      <button type="submit" className="cp-comm-gate-submit" disabled={busy}>
        {busy ? '확인 중…' : submitLabel}
      </button>
    </form>
  );
}
